import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_mst_entity_autodebit_txn_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  e_consent_request_guid: fromDatatype.GuidDataFieldInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  txn_reference: fromDatatype.VarcharDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  property_json: any;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid:  fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid:  fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;  
}

export class bl_fi_mst_entity_autodebit_txn_RowClass
  implements bl_fi_mst_entity_autodebit_txn_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    e_consent_request_guid: fromDatatype.GuidDataFieldInterface;
    txn_date: fromDatatype.TimestampTzDatatypeInterface;
    txn_reference: fromDatatype.VarcharDatatypeInterface;
    amount_txn: fromDatatype.MoneyDatatypeInterface;
    client_source: fromDatatype.VarcharDatatypeInterface;
    client_key: fromDatatype.VarcharDatatypeInterface;
    client_value: fromDatatype.VarcharDatatypeInterface;
    property_json: any;
    namespace: fromDatatype.NamespaceDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid:  fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:  fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;  
}
